export function removePortFromIpAddress(ipAddress: string): string {
  return ipAddress.split(':')[0].trim()
}
